/**
 * The component that allows us to register a route
 */
var Route = function (props) { return props && null; };
export { Route };
